type MakeObj<O extends object> = {
  [K in keyof O]: string;
};

/**
 * Pure method / no context.
 * Inside of payments-platform > processor-data.context, should use `usePaymentsPlatformTrackingIds` instead.
 */
export const useScopedTrackingIds = <O extends object>(baseTrackingId: string, map: O) => {
  return Object.fromEntries(
    Object.entries(map).map(([key, value]) => [key, `${baseTrackingId}:${value}`])
  ) as MakeObj<O>;
};
